import React, { createContext, useState, useEffect } from 'react';
import { auth, db } from "../firebase/firebase"; // Corrected path
import { doc, onSnapshot } from "firebase/firestore";
import { updateUserData, fetchUserData } from "../utils/userData"; // Corrected path

export const PointsVisibilityContext = createContext({
  showPoints: false,
  setShowPoints: () => {}, // This will be the function that also persists to Firestore
});

export const PointsVisibilityProvider = ({ children }) => {
  const [showPoints, setShowPointsState] = useState(false); // Renamed state setter

  // Effect to fetch initial state from Firestore and listen for changes
  useEffect(() => {
    let unsubscribe = () => {};
    const currentUser = auth.currentUser;

    if (currentUser) {
      // Fetch initial value from localStorage for quick UI update
      const fromLS = localStorage.getItem(`showPoints_${currentUser.uid}`);
      if (fromLS !== null) {
        setShowPointsState(JSON.parse(fromLS));
      }

      // Then fetch from Firestore to ensure consistency and get the latest value
      fetchUserData(currentUser.uid).then(userData => {
        if (userData && typeof userData.showPoints === 'boolean') {
          setShowPointsState(userData.showPoints);
          // Update localStorage if Firestore had a different value
          if (JSON.parse(fromLS || "false") !== userData.showPoints) {
            localStorage.setItem(`showPoints_${currentUser.uid}`, JSON.stringify(userData.showPoints));
          }
        } else if (userData && typeof userData.showPoints === 'undefined') {
          // If the value doesn't exist in Firestore, set it based on current state (or default)
          updateUserData(currentUser.uid, { showPoints: showPoints });
        }
      });

      const userDocRef = doc(db, "users", currentUser.uid);
      unsubscribe = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (typeof data.showPoints === 'boolean') {
            setShowPointsState(data.showPoints);
            localStorage.setItem(`showPoints_${currentUser.uid}`, JSON.stringify(data.showPoints));
          }
        }
      });
    }

    return () => unsubscribe();
  }, [auth.currentUser]); // Re-run when auth.currentUser changes

  // Function to update state and persist to Firestore
  const setShowPoints = async (value) => {
    const currentUser = auth.currentUser;
    setShowPointsState(value); // Update local state immediately
    localStorage.setItem(`showPoints_${currentUser?.uid}`, JSON.stringify(value)); // Update LS

    if (currentUser) {
      try {
        await updateUserData(currentUser.uid, { showPoints: value });
      } catch (error) {
        console.error("Failed to update showPoints in Firestore:", error);
        // Optionally, revert state and LS if Firestore update fails
      }
    }
  };

  return (
    <PointsVisibilityContext.Provider value={{ showPoints, setShowPoints }}>
      {children}
    </PointsVisibilityContext.Provider>
  );
};
